export default {
  namespaced: true,
  state: {
    endpoint: "/accounting/invoice",
    key: "accounting_invoice",
    fetchKey: "invoice", // for getting all records from API. clients : [{...},{...},{...}]
    permissionKey: ""
  }
};
